export const Weekly = 'Hebdomadaire';
export const Monthly = 'Mensuel';
export const Quarterly = 'Trimestriel';
export const Annual = 'Annuelle';
